module.exports = __webpack_public_path__ + "img/img_23.fe740e87.png";